import { lazy, useMemo } from 'react';
import { BlockWrapper, smartProps, useEditor, defineBlock, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText, EditableImg } from '@smartfire/components';
import { ReactComponent as Arrow } from '../../assets/arrow.svg';
import { motion } from 'framer-motion';
import clsx from 'clsx';

import style from './block.module.scss';

const Inspector = lazy(() => import('./inspector'));

const SummaryChild = ({ background, linkType, link, targetBlank, parentRef, childIndex, borderColor }) => {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    const href = useMemo(() => {
        switch (linkType) {
            case 'email':
                return 'mailto:' + link;

            case 'tel':
                return 'tel:' + link;

            default:
                return link;
        }
    }, [link, linkType]);

    const Wrapper = BlockWrapper[isEditing ? 'Div' : 'A'];

    return (
        <Wrapper
            className={clsx(style.block, isEditing ? style.admin : style.frontend)}
            href={!isEditing && href ? href : undefined}
            target={targetBlank ? '_blank' : undefined}
            download={linkType === 'file'}
        >
            <motion.div
                className={style.innerBlock}
                style={borderColor !== '' ? { borderColor: borderColor } : null}
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, root: parentRef }}
                transition={{ delay: childIndex / 5 }}
            >
                <div className={style.back}>{background && <img src={background.url} alt={background.alt} />}</div>
                <div className={style.content}>
                    <div className={style.imageContainer}>
                        <EditableImg smartProp={'icon'} className={style.icon} />
                    </div>
                    <EditableText smartProp="title" tagName="h3" placeholder="..." />
                    <EditableText smartProp="text" tagName="p" placeholder="..." />
                    <span>Voir plus</span>
                    <Arrow className={style.arrow} />
                </div>
            </motion.div>
        </Wrapper>
    );
};

export default defineBlock({
    Block: SummaryChild,
    smartProps: {
        background: smartProps.image,
        icon: smartProps.image,
        title: smartProps.string.withDefault(''),
        text: smartProps.string.withDefault(''),
        linkType: smartProps.string.withDefault('other'),
        link: smartProps.string.withDefault(''),
        postType: smartProps.string.withDefault(''),
        fileId: smartProps.number.withDefault(0),
        targetBlank: smartProps.bool.withDefault(false),
        postId: smartProps.number.withDefault(0),
        taxonomy: smartProps.string.withDefault(''),
        termId: smartProps.number.withDefault(0),
        borderColor: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Élement de Sommaire',
        parent: ['smartfire/summary'],
    },
});
